import React from 'react';
import { useTranslation } from 'next-i18next';
import { Menu } from '@mui/material';
import { KeyboardArrowDownRounded } from '@mui/icons-material/';
import AudioSurahSelectorForm from './form';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import s from './styles.module.scss';

interface IAudioSurahSelectorProps {
  currentSurah: AudioSurah;
  surahs: AudioSurah[];
  className?: string;
}

const AudioSurahSelector: React.FC<IAudioSurahSelectorProps> = (props) => {
  const { currentSurah, surahs, className = '' } = props;

  const { t: tButtons } = useTranslation('buttons');

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={className}>
      <button className={s['button']} onClick={handleClick}>
        <span>{tButtons('surah')}</span>
        <i>
          <KeyboardArrowDownRounded />
        </i>
      </button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <AudioSurahSelectorForm
          surahs={surahs}
          currentSurah={currentSurah}
          onClose={handleClose}
        />
      </Menu>
    </div>
  );
};

export default AudioSurahSelector;
